const imageTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/tiff",
  "image/apng",
  "image/avif",
  "image/webp",
];

const useEditPhotoPointPhotos = () => {
  // Check the response for valid parameters.
  const responseValid = ({ response, setStatus, setFetchingPhotos }) => {
    if (
      response == null ||
      response?.status == null ||
      response?.data == null
    ) {
      setStatus("Failed to fetch photos.");
      setFetchingPhotos(false);
      return false;
    }
    if (response.status !== 200) {
      setStatus(`Error: ${response.status} ${response.data}`);
      setFetchingPhotos(false);
      return false;
    }
    return true;
  };

  // Update photos state using the response's data.
  const handleResponse = async ({
    response,
    setFetchingPhotos,
    setPhotos,
    setStatus,
  }) => {
    if (response?.data?.length === 0) {
      setStatus("No photos found.");
      setFetchingPhotos(false);
      setPhotos(null);
      return;
    }
    setPhotos(response.data);
    setFetchingPhotos(false);
  };

  return {
    handleResponse,
    responseValid,
  };
};

export default useEditPhotoPointPhotos;
